<template>
  <div class="group-container">
    <span>{{ groupHeader }}</span>
    <v-layout wrap fill-width>
      <slot name="group-content" />
    </v-layout>
  </div>
</template>

<script>
export default {
  props: {
    groupHeader: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="sass" scoped>
.group-container
  text-align: left
  padding: 1rem
  span
    font-size: 1.2rem
    display: block
    color: $hwayzShadow
</style>
